import { Component, OnInit } from '@angular/core';
declare function init_plugins();

@Component({
  standalone: false,
  selector: 'app-carga-masiva',
  templateUrl: './carga-masiva.component.html',
  styles: []
})
export class CargaMasivaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    init_plugins();

  }

}
